import { render, staticRenderFns } from "./FormAnswerButton.vue?vue&type=template&id=6a1c9893&scoped=true"
import script from "./FormAnswerButton.vue?vue&type=script&lang=js"
export * from "./FormAnswerButton.vue?vue&type=script&lang=js"
import style0 from "./FormAnswerButton.vue?vue&type=style&index=0&id=6a1c9893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c9893",
  null
  
)

export default component.exports